import { defineComponent as d, computed as o, openBlock as c, createElementBlock as i, createElementVNode as t, toDisplayString as n, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "15a0cc0f-440d-41ed-b6db-1a9cd4321907" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#15a0cc0f-440d-41ed-b6db-1a9cd4321907)" }, k = { key: 0 }, p = /* @__PURE__ */ t("path", {
  fill: "#eee",
  d: "M0 0h182.5l88.1 268.5-88 243.5H0z"
}, null, -1), g = /* @__PURE__ */ t("path", {
  fill: "#d80027",
  d: "m182.5 0-82.3 42.7 82.3 42.7-82.3 42.6 82.3 42.7-82.3 42.7 82.3 42.6-82.3 42.7 82.3 42.7-82.3 42.6 82.3 42.7-82.3 42.7 82.3 42.6H512V0H182.5z"
}, null, -1), v = { fill: "none" }, x = ["r"], b = /* @__PURE__ */ d({
  __name: "bh",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), a = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", u, [
        e.flagName ? (c(), i("title", k, n(e.flagName), 1)) : _("", !0),
        p,
        g
      ]),
      t("g", v, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  b as default
};
//# sourceMappingURL=bh-6fdd8d60.js.map
